import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';

export function UsageDisplay({ usage, limits, storage_usado_mb, percentuais }) {
  const getPercentage = (used, limit) => {
    if (!limit) return 0;
    return Math.min((used / limit) * 100, 100);
  };

  const u = usage || {};
  const l = limits || {};
  const p = percentuais || {};

  return (
    <Card>
      <CardHeader>
        <CardTitle>Uso do plano</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <div className="flex justify-between text-sm mb-1">
            <span>Usuários</span>
            <span>{u.usuariosAtivos ?? 0} / {l.usuarios ?? 0}</span>
          </div>
          <Progress value={p.usuarios ?? getPercentage(u.usuariosAtivos ?? 0, l.usuarios)} className="h-2" />
        </div>
        <div>
          <div className="flex justify-between text-sm mb-1">
            <span>Editais (este mês)</span>
            <span>{u.editaisCriados ?? 0} / {l.editais ?? '∞'}</span>
          </div>
          <Progress value={p.editais ?? (l.editais ? getPercentage(u.editaisCriados ?? 0, l.editais) : 0)} className="h-2" />
        </div>
        <div>
          <div className="flex justify-between text-sm mb-1">
            <span>Propostas (este mês)</span>
            <span>{u.propostasCriadas ?? 0} / {l.propostas ?? '∞'}</span>
          </div>
          <Progress value={p.propostas ?? (l.propostas ? getPercentage(u.propostasCriadas ?? 0, l.propostas) : 0)} className="h-2" />
        </div>
        <div>
          <div className="flex justify-between text-sm mb-1">
            <span>Armazenamento</span>
            <span>{Math.round(storage_usado_mb ?? 0)} MB / {(l.storage_mb ?? 0)} MB</span>
          </div>
          <Progress value={l.storage_mb ? getPercentage(storage_usado_mb ?? 0, l.storage_mb) : 0} className="h-2" />
        </div>
      </CardContent>
    </Card>
  );
}
